import React from 'react';
import {
  FiClock,
  FiGrid,
  FiUserCheck,
  FiUserX,
  FiUserMinus,
} from 'react-icons/fi';

import type { SidebarItem } from '@/features/onboarding/components/Sidebar';

/**
 * Standard sidebar items for onboarding pages
 * Blacklist is always shown at the end
 */
export const ONBOARDING_SIDEBAR_ITEMS: SidebarItem[] = [
  {
    label: 'Dashboard',
    path: '/onboarding',
    icon: <FiGrid />,
  },
  {
    label: 'Pré análise',
    path: '/onboarding/pre-analysis',
    icon: <FiClock />,
  },
  {
    label: 'Aprovados',
    path: '/onboarding/approved',
    icon: <FiUserCheck />,
  },
  {
    label: 'Reprovados',
    path: '/onboarding/rejected',
    icon: <FiUserX />,
  },
  {
    label: 'Blacklist',
    path: '/onboarding/blacklist',
    icon: <FiUserMinus />,
  },
];
